import { useDrawer } from '@cast/design-system';

import { ClustersFiltersDrawer } from './ClustersFiltersDrawer';

export const useClustersFiltersDrawer = () => {
  const { open } = useDrawer();

  const openClustersFiltersDrawer = () => {
    open({
      component: ClustersFiltersDrawer,
      props: {},
    });
  };

  return {
    openClustersFiltersDrawer,
  };
};
